import type { ReactNode } from 'react';
import { usePermissionContext } from '../../context/PermissionContext';

interface RequirePermissionProps {
  /** Single permission to check */
  permission?: string;
  /** Pass if ANY of these permissions is present */
  anyOf?: string[];
  /** Rendered when permission is missing (default: nothing) */
  fallback?: ReactNode;
  children: ReactNode;
}

export function RequirePermission({ permission, anyOf, fallback = null, children }: RequirePermissionProps) {
  const { hasPermission, hasAnyPermission, isLoading } = usePermissionContext();

  if (isLoading) return null;

  const allowed = permission
    ? hasPermission(permission)
    : anyOf
      ? hasAnyPermission(anyOf)
      : true;

  if (!allowed) return <>{fallback}</>;
  return <>{children}</>;
}
